export enum USER_LIST_TYPES {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  UNVERIFY = 'UNVERIFY',
  LOCK = 'LOCK',
  BUSINESS = 'BUSINESS',
  INVITATION = 'INVITATION',
}
